import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=611b9923&scoped=true&functional=true&"
import script from "./social-media.vue?vue&type=script&lang=js&"
export * from "./social-media.vue?vue&type=script&lang=js&"
import style0 from "./social-media.vue?vue&type=style&index=0&id=611b9923&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "611b9923",
  null
  
)

export default component.exports